import { Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { fieldIsRequiredMsg } from '../../utils/componentUtils';
import FormDialog from '../Dialogs/FormDialog';
import ReactHookFormTextField from '../ReactHookForm/ReactHookFormTextField';
import { Holiday } from '../../types/Holiday.interface';
import ReactHookFormDatePicker from '../ReactHookForm/ReactHookFormDatePicker';
import ReactHookFormCheckbox from '../ReactHookForm/ReactHookFormCheckbox';
import { useDayjs } from '../../hooks';

interface HolidayDialogProps {
    holiday?: Holiday;
    showDialog: boolean;
    onSubmit: any;
    isLoading: boolean;
    onClose: any;
}

const HolidayDialog: FC<HolidayDialogProps> = ({ holiday, showDialog, onSubmit, isLoading, onClose }) => {
    const { t } = useTranslation();
    const { slotToLocalTime } = useDayjs();
    const form = useForm({
        defaultValues: {
            id: holiday?.id || '',
            name: holiday?.name || '',
            weight: holiday?.weight || 0,
            date: slotToLocalTime(holiday?.date),
            national: holiday?.national || false,
        },
    });
    const {
        formState: { errors },
        control,
    } = form;

    const handleClose = () => {
        onClose();
    };

    return (
        <FormDialog
            title={holiday?.id ? t('holiday.edit') : t('holiday.addNew')}
            showDialog={showDialog}
            form={form}
            onSubmit={onSubmit}
            onClose={handleClose}
            isLoading={isLoading}
            id="holiday-dialog"
        >
            <Grid item xs={12}>
                <ReactHookFormTextField
                    name="name"
                    label={t('field.name')}
                    control={control}
                    rules={{ required: { value: true, message: fieldIsRequiredMsg } }}
                    formErrors={errors}
                    isNumeric={false}
                    defaultValue=""
                    inputProps={undefined}
                    isMultiline={false}
                />
            </Grid>

            <Grid item xs={8}>
                <ReactHookFormDatePicker
                    name="date"
                    control={control}
                    label={t('field.date')}
                    rules={{ required: { value: true, message: fieldIsRequiredMsg } }}
                    formErrors={errors}
                    defaultValue={undefined}
                    minDate={undefined}
                />
            </Grid>
            <Grid item xs={4}>
                <ReactHookFormTextField
                    name="weight"
                    label={t('field.weight')}
                    control={control}
                    rules={{ required: { value: true, message: fieldIsRequiredMsg } }}
                    formErrors={errors}
                    isNumeric={true}
                    defaultValue={0}
                    inputProps={{
                        min: 0,
                        step: 0.1,
                        max: 1,
                        type: 'number',
                    }}
                    isMultiline={false}
                />
            </Grid>
            <Grid item xs={12}>
                <ReactHookFormCheckbox name="national" control={control} label={t('holiday.national')} />
            </Grid>
        </FormDialog>
    );
};

export default HolidayDialog;
